'use strict';

import 'angular';

import './style.css';
import directive from './directive';

var MODULE_NAME = 'daupler.incidents.components.panelOptions';

var app = angular.module(MODULE_NAME, [
]);
app.directive('panelOptions', directive);

export default MODULE_NAME;
